import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Select, Tooltip, Form, Button, Menu } from 'antd';
import { locations, notifications, account } from 'api';
import {
  SettingOutlined
} from '@ant-design/icons';
import FAIcon from 'components/util-components/FAIcon';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons/faShieldHalved'
import { faSpinner, faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck, faCircleX, faHashtag, faFont, faAlignLeft, faSave, faCheckDouble, faCheckSquare, faCalendarAlt, faFileImage, faCode, faGlobe, faLink, faBrush, faPaintBrush, faCaretDown, faFileAlt, faColumns, faGripVertical, faMapPin, faMapMarker, faExternalLinkAlt, faWindowMaximize, faTextHeight, faGripDotsVertical, faPage } from '@fortawesome/pro-light-svg-icons'
import { faLineHeight, faInputText, faBracketsCurly, faBrowser, faLocationPin } from '@fortawesome/pro-light-svg-icons'
import { faMarkdown } from '@fortawesome/free-brands-svg-icons'
import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import { getIconData } from 'utils/icon-list'
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { Modal, Row, Col, Typography, Input } from 'antd';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { isoString } from 'utils/date.util';
const { TextArea } = Input;
const { Option } = Select;

import _ from 'lodash'

export const QuickAlert = () => {

  const history = useHistory()
  const [quickAlertForm] = Form.useForm();
  const [notificationTemplateList, setNotificationTemplateList] = useState([]);
  const [newNotification, setNewNotification] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const [status, setStatus] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedNotification, setSelectedNotification] = useState({
    id: null,
    color: '#ffffff',
    icon: null,
    name: null,
  });
  const [sendStatus, setSendStatus] = useState({
    success: false,
    title: '',
    message: '',
  });

  const colors = {
    primary: '#41abe1',
    accent: '#41abe1',
    black: '#000000',
    pallete: {
      background: '#f7f9fc',
      border: '#e5e9f1',
      green: '#367e43'
    },
    background: '#fff',
    white: '#fff',
    orange: '#DB4914',
    grey: '#808080',
    danger: '#f00000',
    success: '#47C75F',
    error: '#fc5c5d',
    lightGrey: '#eeeeee',
    darkGrey: '#565656'
  }

  const styles = {
    section: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
    menuItem: {
      display: 'flex',
      flexDirection: 'row',
      borderBottom: '1px solid #ccc',
      padding: '5px',
      alignItems: 'center',
      width: '100%',
    },
    value: {
      color: selectedNotification.color, // Ensure selectedNotification is defined in your component
      fontSize: '40px',
      marginBottom: '0px'
    },
    text: {
      color: selectedNotification.color, // Ensure selectedNotification is defined in your component
    },
    timer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    error: {
      backgroundColor: '#f7d0c9',
      padding: '10px 5px',
      borderRadius: '4px',
      margin: '5px 0',
      display: 'flex',
      flexDirection: 'row',
      boxShadow: '2px 2px 5px 0px rgba(0,0,0,0.25)',
    },
  };

  useEffect(() => {
    loadLocationList();
    loadNotificationTemplatesList();
  }, [])

  const loadLocationList = async () => {
    const queryString = '?return_all=true'
    const location_result = await locations.list(queryString);
    setLocationList(location_result?.locations)
  }

  const loadNotificationTemplatesList = async () => {
    const account_notification_templatees = await account.notificationTemplates();
    setNotificationTemplateList(account_notification_templatees?.notification_templates)
  }

  const [modalVisible, setModalVisible] = useState(false);
  const showModal = () => {
    setModalVisible(true)
  };
  const onModalClose = () => {
    quickAlertForm.resetFields();
    setProcessing(false)
    setNewNotification(null)
    setStatus(null);
    setModalVisible(false)
  }

  const icons = getIconData();
  const renderNotificationTemplate = (record) => {
    const filtered_icons = _.filter(icons, { 'code': record?.notification_type.icon })
    const icon = filtered_icons[0].icon;
    return (
      <div style={{
        backgroundColor: record?.notification_type.color,
        border: 'none',
        color: 'white',
        padding: '7px 16px',
        textAlign: 'left',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: '16px',
        borderRadius: '5px',
        width: '100%'
      }}>
        <FAIcon icon={icon} /> {record.name}
      </div >
    )
  }
  
  const handleSelectLocation = async (item) => {
    const filtered_locations = _.filter(locationList, { 'id': item })
    const location = filtered_locations[0];
    setSelectedLocation({
      display_name: location.name,
      location_id: location.id,
    });
 
  }

  const handleSelectNotification = async (item) => {

    quickAlertForm
      .validateFields()
      .then(async (values) => {

        setSelectedNotification({
          id: item.id,
          color: item.notification_type.color,
          icon: item.notification_type.icon,
          name: item.notification_type.name,
        });
        setStatus('sending');

      })
      .catch((error) => {
      });
  }


  const sendNotification = async () => {
    setProcessing(true)


    const location_id = quickAlertForm.getFieldValue('location_id')
    const additional_details = quickAlertForm.getFieldValue('additional_details')
    let body = {
      location_id: location_id,
      additional_details: additional_details,
      template_id: selectedNotification.id,
      timestamp: isoString(),
    }

    notifications.quickNotification(body).then(async (response) => {
      if (response?.notification?.id) {
        setNewNotification(response?.notification?.id)
        setStatus('sent');
        setSendStatus({
          success: true,
          title: 'Success',
          message: 'Your notification has been successfully sent!',
        });
      }
    })
      .catch((error) => {
        setStatus('sent');
        setSendStatus({
          success: false,
          title: 'Error',
          message: 'An error occured! Your notification was not sent!',
        });
      })
  }; 

  const handleSendNow = async () => {
    await sendNotification();
  };

  const handleCancelSend = async () => {
    onModalClose();
  };

  const handleOk = async () => {
    if(newNotification) {
      history.push(`/notifications/${newNotification}`)
    }
    onModalClose();
  };

  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return <p style={styles.timer}>Notification Sent...</p>;
    }

    return (
      <div style={styles.timer}>
        <p style={styles.value}>{remainingTime}</p>
        <p style={styles.text}>Seconds</p>
      </div>
    );
  };

  const UrgeWithPleasureComponent = () => (
    <>
      <div style={{ margin: 15, textAlign: 'center', margin: '0 auto' }}>
        <p
          style={{
            marginTop: 20,
            fontSize: 20,
            fontWeight: '400',
            textAlign: 'center',
            alignSelf: 'center',
            color: '#455560'
          }}>
          Sending Notification In:{' '}
        </p>
        <div className='app-countdown-container' style={{ margin: '0 auto', textAlign: 'center' }}>
          <CountdownCircleTimer
            key={0}
            isPlaying
            duration={5}
            colors={selectedNotification?.color}
            onComplete={async () => {
              await sendNotification();
              return { shouldRepeat: false };
            }}
            style={{
              margin: '0 auto',
            }}
          >
            {renderTime}
          </CountdownCircleTimer>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Menu mode="horizontal" className="app-header-settings-menu">
        <Menu.Item key="settings" onClick={showModal} className="app-header-top-nav-menu-item">
          <Button className="nav-icon mr-0 fa-btn-i" type="default" shape="circle" icon={<FAIcon icon={faShieldHalved} className='menu-anticon' />} />
        </Menu.Item>
      </Menu>

      <Modal
        autoFocus={true}
        mask={true}
        closable={true}
        maskClosable={true}
        centered={true}
        title={'Quick Notification'}
        visible={modalVisible}
        onClose={onModalClose}
        onCancel={onModalClose}
        zIndex={9999}
        footer={<></>}
      >
        {!status && (<>
          <Form
            layout={'vertical'}
            form={quickAlertForm}
            requiredMark={false}
          >
            <Form.Item
              name="location_id"
              label={<div style={{ fontSize: 16, fontWeight: '400' }}>Location</div>}
              className="dark-input "
              rules={[{ required: true, message: 'A Location is Required' }]}
            >
              <Select
                style={{ width: '100%' }}
                onChange={handleSelectLocation}
              >
                {locationList.map((location) => <Select.Option key={location.id} value={location.id}>{location.name} ({location.formatted_address})</Select.Option>)}
              </Select>
            </Form.Item>

            <Form.Item
              name="additional_details"
              label={<div style={{ fontSize: 16, fontWeight: '400' }}>Additional Details</div>}
            >
              <TextArea />
            </Form.Item>
          </Form>
          <ul className="content-elements-list" key="elements">
            <Row gutter={ROW_GUTTER}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} key={'new'}>
                <div style={{ fontSize: 16, fontWeight: '400' }}>Send Notification</div>
              </Col>
            </Row>
            <Row gutter={ROW_GUTTER}>
              {notificationTemplateList.map((item, index) => (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} key={index} style={{ paddingTop: 15 }}>

                  <li key={item.name} className="content-element content-element-item" onClick={() => handleSelectNotification(item)} >
                    {renderNotificationTemplate(item)}
                  </li>
                </Col>
              ))}
            </Row>
          </ul>
        </>
        )}
        {status === 'sending' && (
          <>
            <div style={{ flex: 1, borderRadius: 10, alignSelf: 'center' }}>
              <div style={{ flex: 1, padding: 10 }}>
                <div
                  style={{
                    flex: 0.75,
                    width: '100%',
                    alignItems: 'center',
                    alignSelf: 'center',
                    borderWidth: 1,
                    borderColor: '#ccc',
                    borderStyle: 'solid',
                    padding: 10,
                    backgroundColor: '#fff',
                  }}>
                  <div
                    style={{
                      textAlign: 'center',
                    }}>

                    <div
                      style={{
                        fontSize: 20,
                        fontWeight: '600',
                        color: selectedNotification?.color,
                      }}>
                      <FAIcon
                        icon={faShieldHalved}
                        size={'sm'}
                        color={selectedNotification?.color}
                      />
                      <span style={{ paddingLeft: 10 }}>
                        {selectedNotification?.name}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      marginVertical: 1,
                      fontSize: 20,
                      color: '#555',
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    {selectedLocation?.display_name}
                  </div>
                </div>
                <div
                  style={{
                    flex: 3,
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center',
                    padding: 10,
                  }}>
                  {UrgeWithPleasureComponent()}
                </div>

                <Row gutter={ROW_GUTTER} style={{ textAlign: 'center' }}>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} offset={6} style={{ paddingTop: 15 }}>
                    <Button loading={processing} type="primary" block size='large' style={{ background: selectedNotification?.color, borderColor: selectedNotification?.color }}
                      onClick={handleSendNow}
                    >
                      SEND NOW
                    </Button>
                  </Col>
                </Row>
                <Row gutter={ROW_GUTTER}>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} offset={6} style={{ paddingTop: 35 }}>
                    <Button danger ghost block size='large'
                      onClick={handleCancelSend}
                    >
                      CANCEL NOTIFICATION
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </>
        )}
        {status === 'sent' && (
          <>
            <div
              style={{
                flex: 0.5,
                flexDirection: 'column',
                backgroundColor: 'white',
                borderRadius: 10,
                alignSelf: 'center',
              }}>
              <div
                style={{ textAlign: 'center' }}>
                {sendStatus.success ? (
                  <FAIcon
                    icon={faCircleCheck}
                    size={'7x'}
                    color={colors.success}
                  />
                ) : (
                  <FAIcon
                    icon={faCircleX}
                    size={'7x'}
                    color={colors.error}
                  />
                )}
              </div>
              <div
                style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: 40,
                    paddingTop: 20,
                    color: sendStatus.success ? colors.success : colors.error,
                    fontWeight: '400',
                  }}>
                  {sendStatus.title}
                </div>
                <div
                  style={{
                    textAlign: 'center',
                    paddingTop: 10,
                    paddingBottom: 20,
                    paddingLeft: 10,
                    paddingRight: 10,
                    fontSize: 20,
                    color: colors.black,
                    fontWeight: '400',
                  }}>
                  {sendStatus.message}
                </div>
              </div>
              <div style={{ flex: 1 }}>

                <Row gutter={ROW_GUTTER}>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} offset={6} style={{ paddingTop: 35 }}>
                    <Button type='primary' block size='large'
                      onClick={handleOk}
                    >
                      {sendStatus.success ? 'CONTINUE' : 'TRY AGAIN'}
                    </Button>
                  </Col>
                </Row>

              </div>
            </div>
          </>
        )}
      </Modal>
    </>
  );
}

export default QuickAlert; 
